/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendIdDto } from '../models/backend-id-dto';
import { BackendOpexDto } from '../models/backend-opex-dto';
import { BackendOpexVariantDto } from '../models/backend-opex-variant-dto';
import { salesOpexsCopyCreate } from '../fn/opexs/sales-opexs-copy-create';
import { SalesOpexsCopyCreate$Params } from '../fn/opexs/sales-opexs-copy-create';
import { salesOpexsCreate } from '../fn/opexs/sales-opexs-create';
import { salesOpexsCreate$FormData } from '../fn/opexs/sales-opexs-create-form-data';
import { SalesOpexsCreate$FormData$Params } from '../fn/opexs/sales-opexs-create-form-data';
import { SalesOpexsCreate$Params } from '../fn/opexs/sales-opexs-create';
import { salesOpexsCreate$XWwwFormUrlencoded } from '../fn/opexs/sales-opexs-create-x-www-form-urlencoded';
import { SalesOpexsCreate$XWwwFormUrlencoded$Params } from '../fn/opexs/sales-opexs-create-x-www-form-urlencoded';
import { salesOpexsDestroy } from '../fn/opexs/sales-opexs-destroy';
import { SalesOpexsDestroy$Params } from '../fn/opexs/sales-opexs-destroy';
import { salesOpexsDestroy2 } from '../fn/opexs/sales-opexs-destroy-2';
import { SalesOpexsDestroy2$Params } from '../fn/opexs/sales-opexs-destroy-2';
import { salesOpexsEnumsRetrieve } from '../fn/opexs/sales-opexs-enums-retrieve';
import { SalesOpexsEnumsRetrieve$Params } from '../fn/opexs/sales-opexs-enums-retrieve';
import { salesOpexsList } from '../fn/opexs/sales-opexs-list';
import { SalesOpexsList$Params } from '../fn/opexs/sales-opexs-list';
import { salesOpexsPartialUpdate } from '../fn/opexs/sales-opexs-partial-update';
import { salesOpexsPartialUpdate$FormData } from '../fn/opexs/sales-opexs-partial-update-form-data';
import { SalesOpexsPartialUpdate$FormData$Params } from '../fn/opexs/sales-opexs-partial-update-form-data';
import { SalesOpexsPartialUpdate$Params } from '../fn/opexs/sales-opexs-partial-update';
import { salesOpexsPartialUpdate$XWwwFormUrlencoded } from '../fn/opexs/sales-opexs-partial-update-x-www-form-urlencoded';
import { SalesOpexsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs/sales-opexs-partial-update-x-www-form-urlencoded';
import { salesOpexsProductVariantsRetrieve } from '../fn/opexs/sales-opexs-product-variants-retrieve';
import { SalesOpexsProductVariantsRetrieve$Params } from '../fn/opexs/sales-opexs-product-variants-retrieve';
import { salesOpexsRetrieve } from '../fn/opexs/sales-opexs-retrieve';
import { SalesOpexsRetrieve$Params } from '../fn/opexs/sales-opexs-retrieve';
import { salesOpexsUpdate } from '../fn/opexs/sales-opexs-update';
import { salesOpexsUpdate$FormData } from '../fn/opexs/sales-opexs-update-form-data';
import { SalesOpexsUpdate$FormData$Params } from '../fn/opexs/sales-opexs-update-form-data';
import { SalesOpexsUpdate$Params } from '../fn/opexs/sales-opexs-update';
import { salesOpexsUpdate$XWwwFormUrlencoded } from '../fn/opexs/sales-opexs-update-x-www-form-urlencoded';
import { SalesOpexsUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs/sales-opexs-update-x-www-form-urlencoded';
import { salesOpexVariantsCopyCreate } from '../fn/opexs/sales-opex-variants-copy-create';
import { SalesOpexVariantsCopyCreate$Params } from '../fn/opexs/sales-opex-variants-copy-create';
import { salesOpexVariantsCreate } from '../fn/opexs/sales-opex-variants-create';
import { salesOpexVariantsCreate$FormData } from '../fn/opexs/sales-opex-variants-create-form-data';
import { SalesOpexVariantsCreate$FormData$Params } from '../fn/opexs/sales-opex-variants-create-form-data';
import { SalesOpexVariantsCreate$Params } from '../fn/opexs/sales-opex-variants-create';
import { salesOpexVariantsCreate$XWwwFormUrlencoded } from '../fn/opexs/sales-opex-variants-create-x-www-form-urlencoded';
import { SalesOpexVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/opexs/sales-opex-variants-create-x-www-form-urlencoded';
import { salesOpexVariantsDestroy } from '../fn/opexs/sales-opex-variants-destroy';
import { SalesOpexVariantsDestroy$Params } from '../fn/opexs/sales-opex-variants-destroy';
import { salesOpexVariantsList } from '../fn/opexs/sales-opex-variants-list';
import { SalesOpexVariantsList$Params } from '../fn/opexs/sales-opex-variants-list';
import { salesOpexVariantsPartialUpdate } from '../fn/opexs/sales-opex-variants-partial-update';
import { salesOpexVariantsPartialUpdate$FormData } from '../fn/opexs/sales-opex-variants-partial-update-form-data';
import { SalesOpexVariantsPartialUpdate$FormData$Params } from '../fn/opexs/sales-opex-variants-partial-update-form-data';
import { SalesOpexVariantsPartialUpdate$Params } from '../fn/opexs/sales-opex-variants-partial-update';
import { salesOpexVariantsPartialUpdate$XWwwFormUrlencoded } from '../fn/opexs/sales-opex-variants-partial-update-x-www-form-urlencoded';
import { SalesOpexVariantsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs/sales-opex-variants-partial-update-x-www-form-urlencoded';
import { salesOpexVariantsRetrieve } from '../fn/opexs/sales-opex-variants-retrieve';
import { SalesOpexVariantsRetrieve$Params } from '../fn/opexs/sales-opex-variants-retrieve';
import { salesOpexVariantsUpdate } from '../fn/opexs/sales-opex-variants-update';
import { salesOpexVariantsUpdate$FormData } from '../fn/opexs/sales-opex-variants-update-form-data';
import { SalesOpexVariantsUpdate$FormData$Params } from '../fn/opexs/sales-opex-variants-update-form-data';
import { SalesOpexVariantsUpdate$Params } from '../fn/opexs/sales-opex-variants-update';
import { salesOpexVariantsUpdate$XWwwFormUrlencoded } from '../fn/opexs/sales-opex-variants-update-x-www-form-urlencoded';
import { SalesOpexVariantsUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs/sales-opex-variants-update-x-www-form-urlencoded';
import { salesUnblockOpexsVariantsCreate } from '../fn/opexs/sales-unblock-opexs-variants-create';
import { salesUnblockOpexsVariantsCreate$FormData } from '../fn/opexs/sales-unblock-opexs-variants-create-form-data';
import { SalesUnblockOpexsVariantsCreate$FormData$Params } from '../fn/opexs/sales-unblock-opexs-variants-create-form-data';
import { SalesUnblockOpexsVariantsCreate$Params } from '../fn/opexs/sales-unblock-opexs-variants-create';
import { salesUnblockOpexsVariantsCreate$XWwwFormUrlencoded } from '../fn/opexs/sales-unblock-opexs-variants-create-x-www-form-urlencoded';
import { SalesUnblockOpexsVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/opexs/sales-unblock-opexs-variants-create-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiOpexsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `salesOpexVariantsList()` */
  static readonly SalesOpexVariantsListPath = '/api/sales/opex_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexVariantsList$Response(
    params?: SalesOpexVariantsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendOpexVariantDto>>> {
    return salesOpexVariantsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexVariantsList(
    params?: SalesOpexVariantsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendOpexVariantDto>> {
    return this.salesOpexVariantsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendOpexVariantDto>>): Array<BackendOpexVariantDto> => r.body),
    );
  }

  /** Path part for operation `salesOpexVariantsCreate()` */
  static readonly SalesOpexVariantsCreatePath = '/api/sales/opex_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexVariantsCreate$Response(
    params: SalesOpexVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexVariantsCreate(
    params: SalesOpexVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexVariantsCreate$XWwwFormUrlencoded$Response(
    params: SalesOpexVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexVariantsCreate$XWwwFormUrlencoded(
    params: SalesOpexVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexVariantsCreate$FormData$Response(
    params: SalesOpexVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexVariantsCreate$FormData(
    params: SalesOpexVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /** Path part for operation `salesOpexVariantsRetrieve()` */
  static readonly SalesOpexVariantsRetrievePath = '/api/sales/opex_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexVariantsRetrieve$Response(
    params: SalesOpexVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexVariantsRetrieve(
    params: SalesOpexVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /** Path part for operation `salesOpexVariantsUpdate()` */
  static readonly SalesOpexVariantsUpdatePath = '/api/sales/opex_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexVariantsUpdate$Response(
    params: SalesOpexVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexVariantsUpdate(
    params: SalesOpexVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexVariantsUpdate$XWwwFormUrlencoded$Response(
    params: SalesOpexVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexVariantsUpdate$XWwwFormUrlencoded(
    params: SalesOpexVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexVariantsUpdate$FormData$Response(
    params: SalesOpexVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexVariantsUpdate$FormData(
    params: SalesOpexVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /** Path part for operation `salesOpexVariantsDestroy()` */
  static readonly SalesOpexVariantsDestroyPath = '/api/sales/opex_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexVariantsDestroy$Response(
    params: SalesOpexVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesOpexVariantsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexVariantsDestroy(params: SalesOpexVariantsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.salesOpexVariantsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesOpexVariantsPartialUpdate()` */
  static readonly SalesOpexVariantsPartialUpdatePath = '/api/sales/opex_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexVariantsPartialUpdate$Response(
    params: SalesOpexVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexVariantsPartialUpdate(
    params: SalesOpexVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexVariantsPartialUpdate$XWwwFormUrlencoded$Response(
    params: SalesOpexVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexVariantsPartialUpdate$XWwwFormUrlencoded(
    params: SalesOpexVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexVariantsPartialUpdate$FormData$Response(
    params: SalesOpexVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return salesOpexVariantsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexVariantsPartialUpdate$FormData(
    params: SalesOpexVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.salesOpexVariantsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /** Path part for operation `salesOpexVariantsCopyCreate()` */
  static readonly SalesOpexVariantsCopyCreatePath = '/api/sales/opex_variants/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexVariantsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexVariantsCopyCreate$Response(
    params: SalesOpexVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesOpexVariantsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexVariantsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexVariantsCopyCreate(params: SalesOpexVariantsCopyCreate$Params, context?: HttpContext): Observable<void> {
    return this.salesOpexVariantsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesOpexsList()` */
  static readonly SalesOpexsListPath = '/api/sales/opexs/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsList$Response(
    params?: SalesOpexsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendOpexDto>>> {
    return salesOpexsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsList(params?: SalesOpexsList$Params, context?: HttpContext): Observable<Array<BackendOpexDto>> {
    return this.salesOpexsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendOpexDto>>): Array<BackendOpexDto> => r.body),
    );
  }

  /** Path part for operation `salesOpexsCreate()` */
  static readonly SalesOpexsCreatePath = '/api/sales/opexs/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexsCreate$Response(
    params: SalesOpexsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexsCreate(params: SalesOpexsCreate$Params, context?: HttpContext): Observable<BackendOpexDto> {
    return this.salesOpexsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexsCreate$XWwwFormUrlencoded$Response(
    params: SalesOpexsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexsCreate$XWwwFormUrlencoded(
    params: SalesOpexsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOpexDto> {
    return this.salesOpexsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexsCreate$FormData$Response(
    params: SalesOpexsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexsCreate$FormData(
    params: SalesOpexsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOpexDto> {
    return this.salesOpexsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /** Path part for operation `salesOpexsDestroy()` */
  static readonly SalesOpexsDestroyPath = '/api/sales/opexs/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsDestroy$Response(
    params?: SalesOpexsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesOpexsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsDestroy(params?: SalesOpexsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.salesOpexsDestroy$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `salesOpexsRetrieve()` */
  static readonly SalesOpexsRetrievePath = '/api/sales/opexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsRetrieve$Response(
    params: SalesOpexsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsRetrieve(params: SalesOpexsRetrieve$Params, context?: HttpContext): Observable<BackendOpexDto> {
    return this.salesOpexsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /** Path part for operation `salesOpexsUpdate()` */
  static readonly SalesOpexsUpdatePath = '/api/sales/opexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexsUpdate$Response(
    params: SalesOpexsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexsUpdate(params: SalesOpexsUpdate$Params, context?: HttpContext): Observable<BackendOpexDto> {
    return this.salesOpexsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexsUpdate$XWwwFormUrlencoded$Response(
    params: SalesOpexsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexsUpdate$XWwwFormUrlencoded(
    params: SalesOpexsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOpexDto> {
    return this.salesOpexsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexsUpdate$FormData$Response(
    params: SalesOpexsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexsUpdate$FormData(
    params: SalesOpexsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOpexDto> {
    return this.salesOpexsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /** Path part for operation `salesOpexsDestroy2()` */
  static readonly SalesOpexsDestroy2Path = '/api/sales/opexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsDestroy2()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsDestroy2$Response(
    params: SalesOpexsDestroy2$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesOpexsDestroy2(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsDestroy2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsDestroy2(params: SalesOpexsDestroy2$Params, context?: HttpContext): Observable<void> {
    return this.salesOpexsDestroy2$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `salesOpexsPartialUpdate()` */
  static readonly SalesOpexsPartialUpdatePath = '/api/sales/opexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexsPartialUpdate$Response(
    params: SalesOpexsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesOpexsPartialUpdate(params: SalesOpexsPartialUpdate$Params, context?: HttpContext): Observable<BackendOpexDto> {
    return this.salesOpexsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexsPartialUpdate$XWwwFormUrlencoded$Response(
    params: SalesOpexsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesOpexsPartialUpdate$XWwwFormUrlencoded(
    params: SalesOpexsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOpexDto> {
    return this.salesOpexsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexsPartialUpdate$FormData$Response(
    params: SalesOpexsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexDto>> {
    return salesOpexsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesOpexsPartialUpdate$FormData(
    params: SalesOpexsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOpexDto> {
    return this.salesOpexsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexDto>): BackendOpexDto => r.body),
    );
  }

  /** Path part for operation `salesOpexsCopyCreate()` */
  static readonly SalesOpexsCopyCreatePath = '/api/sales/opexs/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsCopyCreate$Response(
    params: SalesOpexsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesOpexsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsCopyCreate(params: SalesOpexsCopyCreate$Params, context?: HttpContext): Observable<void> {
    return this.salesOpexsCopyCreate$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `salesOpexsEnumsRetrieve()` */
  static readonly SalesOpexsEnumsRetrievePath = '/api/sales/opexs/enums/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsEnumsRetrieve$Response(
    params: SalesOpexsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesOpexsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsEnumsRetrieve(params: SalesOpexsEnumsRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.salesOpexsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesOpexsProductVariantsRetrieve()` */
  static readonly SalesOpexsProductVariantsRetrievePath = '/api/sales/opexs/product_variants/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesOpexsProductVariantsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsProductVariantsRetrieve$Response(
    params: SalesOpexsProductVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesOpexsProductVariantsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesOpexsProductVariantsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesOpexsProductVariantsRetrieve(
    params: SalesOpexsProductVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.salesOpexsProductVariantsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesUnblockOpexsVariantsCreate()` */
  static readonly SalesUnblockOpexsVariantsCreatePath = '/api/sales/unblock-opexs-variants/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesUnblockOpexsVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesUnblockOpexsVariantsCreate$Response(
    params: SalesUnblockOpexsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return salesUnblockOpexsVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesUnblockOpexsVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesUnblockOpexsVariantsCreate(
    params: SalesUnblockOpexsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.salesUnblockOpexsVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesUnblockOpexsVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesUnblockOpexsVariantsCreate$XWwwFormUrlencoded$Response(
    params: SalesUnblockOpexsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return salesUnblockOpexsVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesUnblockOpexsVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesUnblockOpexsVariantsCreate$XWwwFormUrlencoded(
    params: SalesUnblockOpexsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.salesUnblockOpexsVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesUnblockOpexsVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesUnblockOpexsVariantsCreate$FormData$Response(
    params: SalesUnblockOpexsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return salesUnblockOpexsVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesUnblockOpexsVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesUnblockOpexsVariantsCreate$FormData(
    params: SalesUnblockOpexsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.salesUnblockOpexsVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }
}
